<script lang="ts">
  /**
   * A group of option rows, set apart from the group above it by a gap and a
   * rule — how "Leave for now" is kept visibly away from "Abandon". The label
   * is optional; when given it is a small heading the rows sit under, and the
   * group is named by it for assistive technology.
   */
  import type { Snippet } from 'svelte';

  interface Props {
    readonly label?: string | undefined;
    readonly children: Snippet;
    readonly testid?: string | undefined;
  }
  const { label, children, testid }: Props = $props();

  const labelId = $props.id();
</script>

<div
  class="ui-option-section"
  role="group"
  aria-labelledby={label === undefined ? undefined : labelId}
  data-testid={testid}
>
  {#if label !== undefined}
    <p id={labelId} class="ui-option-section-label">{label}</p>
  {/if}
  {@render children()}
</div>

<style>
  .ui-option-section {
    display: flex;
    flex-direction: column;
  }

  .ui-option-section:not(:first-child) {
    margin-top: var(--ui-space-3);
    padding-top: var(--ui-space-2);
    border-top: 6px solid var(--ui-surface-2);
  }

  .ui-option-section-label {
    margin: var(--ui-space-2) 0 0;
    font: var(--ui-text-eyebrow);
    letter-spacing: var(--ui-tracking-eyebrow);
    text-transform: uppercase;
    color: var(--ui-ink-2);
  }
</style>
